import { useMutation } from '@tanstack/react-query';

import queryClient from '../../lib/queryClient';

import { triggerSnackbar } from '../../provider/SnackbarProvider';
import { deleteMedication } from '../../apis/medication';

const useDeleteMedication = () => {
  return useMutation({
    mutationKey: ['delete-medication'],
    mutationFn: async (medicationId: number | undefined) => {
      return await deleteMedication(medicationId);
    },
    onSuccess: (data) => {
      triggerSnackbar({
        message: data?.message,
        severity: 'success',
      });
      queryClient.invalidateQueries({ queryKey: ['medication-list'] });
      queryClient.invalidateQueries({ queryKey: ['medication-reminder-list'] });
      queryClient.invalidateQueries({ queryKey: ['medication-consistency'] });
    },
    onError: (error) => {
      triggerSnackbar({
        message: error.message,
        severity: 'error',
      });
    },
  });
};

export default useDeleteMedication;
